import { CounterPartys } from "./types";
import { AuthSelectors } from "src/redux/Auth/selectors";
import fetchWrapper from "src/utils/fetchWrapper";

export const CounterPartysActions = {
    GetAll: () => {
        return (dispatch, getState) => {
            const state = getState();
            const url = AuthSelectors.BuildDirectoryUrl(state, "/cpty");

            // request to server for data
            return dispatch(fetchWrapper(url))
                .then((result) => {
                    dispatch({
                        type: CounterPartys.SET,
                        result,
                    });
                })
                .catch((error) => {
                    dispatch({
                        type: CounterPartys.ERROR,
                        error: error.message,
                    });
                });
        };
    },

    Get: (id) => {
        return (dispatch, getState) => {
            const state = getState();
            const url = AuthSelectors.BuildDirectoryUrl(state, `/cpty/${id}`);

            return dispatch(
                fetchWrapper(url, {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                })
            )
                .then((result) => {
                    let uiCpty = {
                        id: result.cptyCode,
                        name: result.cptyName,
                        myCpty: result.myCpty,
                        entries: result.entries,
                        intermediarySettings: result.intermediarySettings,
                    };

                    dispatch({
                        type: CounterPartys.UPDATE,
                        result: {
                            cptys: [uiCpty],
                        },
                    });

                    return new Promise((resolve) => resolve(uiCpty));
                })
                .catch((error) => {
                    dispatch({
                        type: CounterPartys.ERROR,
                        error: error.message,
                    });
                });
        };
    },
};
